export default "__VITE_ASSET__4586cb73__"